/*
 * Copyright (c) 2020. Sanish Manandhar
 * All Rights Reserved
 */

import {
  TASK_CLEAN_REQUEST,
  TASK_FETCH_REQUEST,
  TASK_FETCH_REQUEST_SUCCESS,
  TASK_FETCH_REQUEST_FAILURE,
  TASK_UPSERT_REQUEST,
  TASK_UPSERT_REQUEST_SUCCESS,
  TASK_UPSERT_REQUEST_FAILURE,
  SINGLE_TASK_UPSERT_REQUEST,
  SINGLE_TASK_UPSERT_REQUEST_SUCCESS,
  SINGLE_TASK_UPSERT_REQUEST_FAILURE,
  SINGLE_TASK_CLEAN_REQUEST,
  SINGLE_TASK_FETCH_REQUEST,
  SINGLE_TASK_FETCH_REQUEST_SUCCESS,
  SINGLE_TASK_FETCH_REQUEST_FAILURE,
  TASK_REASSIGN_REQUEST,
  TASK_REASSIGN_REQUEST_SUCCESS,
  TASK_REASSIGN_REQUEST_FAILURE,
  TASK_SKIP_REQUEST,
  TASK_SKIP_REQUEST_SUCCESS,
  TASK_SKIP_REQUEST_FAILURE,
  TASK_PARK_REQUEST,
  TASK_PARK_REQUEST_SUCCESS,
  TASK_PARK_REQUEST_FAILURE,
  TASK_LIST_UPSERT_INDEX_REQUEST,
  TASK_LIST_UPSERT_INDEX_REQUEST_SUCCESS,
  TASK_LIST_UPSERT_INDEX_REQUEST_FAILURE,
  FETCH_SUBTASKS_REQUEST,
  FETCH_SUBTASKS_REQUEST_SUCCESS,
  FETCH_SUBTASKS_REQUEST_FAILURE,
  TASK_ERRORS_CLEAN_REQUEST,
  TASK_TITLE_LIST_FETCH_REQUEST,
  TASK_TITLE_LIST_FETCH_REQUEST_SUCCESS,
  TASK_TITLE_LIST_FETCH_REQUEST_FAILURE,
  FETCH_TASK_BY_IDENTIFICATION_REQUEST,
  FETCH_TASK_BY_IDENTIFICATION_REQUEST_SUCCESS,
  FETCH_TASK_BY_IDENTIFICATION_REQUEST_FAILURE,
  SINGLE_TASK_COMPLETE_ALL_REQUEST,
  SINGLE_TASK_COMPLETE_ALL_REQUEST_SUCCESS,
  SINGLE_TASK_COMPLETE_ALL_REQUEST_FAILURE,
  MARK_TASK_UNREAD_REQUEST,
  MARK_TASK_UNREAD_REQUEST_SUCCESS,
  MARK_TASK_UNREAD_REQUEST_FAILURE,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  taskTitleList: [],
  taskTitleListErrors: {},
  taskTitleListLoading: false,
  singlePayload: [],
  singleLoading: false,
  singleErrors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  indexUpdatePayload: [],
  indexUpdateLoading: false,
  indexUpdateErrors: {},
  dropdown: [],
  dropdownLoading: false,
  dropdownErrors: {},
  taskReassign: [],
  taskReassignLoading: false,
  taskReassignErrors: {},
  taskSkip: [],
  taskSkipLoading: false,
  taskSkipErrors: {},
  taskPark: [],
  taskParkErrors: {},
  taskParkLoading: false,
  subTasksPayload: [],
  subTasksLoading: false,
  subTasksErrors: {},
  taskById: [],
  taskByIdLoading: false,
  taskByIdErrors: {},
  markTaskUnreadResponse: [],
  markTaskUnreadLoading: false,
  markTaskUnreadErrors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const taskReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TASK_FETCH_REQUEST:
    case TASK_UPSERT_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SINGLE_TASK_COMPLETE_ALL_REQUEST:
    case SINGLE_TASK_UPSERT_REQUEST:
    case SINGLE_TASK_FETCH_REQUEST:
      return Object.assign({}, state, {
        singleLoading: true,
      });

    case TASK_FETCH_REQUEST_SUCCESS:
    case TASK_UPSERT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
        },
      });

    case SINGLE_TASK_COMPLETE_ALL_REQUEST_SUCCESS:
    case SINGLE_TASK_UPSERT_REQUEST_SUCCESS:
    case SINGLE_TASK_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singleLoading: false,
        singlePayload: action.data,
        singleErrors: {},
      });

    case TASK_FETCH_REQUEST_FAILURE:
    case TASK_UPSERT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SINGLE_TASK_COMPLETE_ALL_REQUEST_FAILURE:
    case SINGLE_TASK_UPSERT_REQUEST_FAILURE:
    case SINGLE_TASK_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singleLoading: false,
        singleErrors: action.error,
      });

    case SINGLE_TASK_CLEAN_REQUEST:
      return Object.assign({}, state, {
        singlePayload: [],
        singleLoading: false,
        singleErrors: {},
      });

    case TASK_REASSIGN_REQUEST:
      return Object.assign({}, state, {
        taskReassignLoading: true,
      });

    case TASK_REASSIGN_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        taskReassignLoading: false,
        taskReassign: action.data,
        taskReassignErrors: {},
      });

    case TASK_REASSIGN_REQUEST_FAILURE:
      return Object.assign({}, state, {
        taskReassignLoading: false,
        taskReassignErrors: action.error,
      });

    case TASK_SKIP_REQUEST:
      return Object.assign({}, state, {
        taskSkipLoading: true,
      });

    case TASK_SKIP_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        taskSkipLoading: false,
        taskSkip: action.data,
        taskSkipErrors: {},
      });

    case TASK_SKIP_REQUEST_FAILURE:
      return Object.assign({}, state, {
        taskSkipLoading: false,
        taskSkipErrors: action.error,
      });

    case TASK_PARK_REQUEST:
      return Object.assign({}, state, {
        taskParkLoading: true,
      });

    case TASK_PARK_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        taskParkLoading: false,
        taskPark: action.data,
        taskParkErrors: {},
      });

    case TASK_PARK_REQUEST_FAILURE:
      return Object.assign({}, state, {
        taskParkLoading: false,
        taskParkErrors: action.error,
      });

    case TASK_TITLE_LIST_FETCH_REQUEST:
      return Object.assign({}, state, {
        taskTitleListLoading: true,
      });

    case TASK_TITLE_LIST_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        taskTitleListLoading: false,
        taskTitleList: action.data,
        taskTitleListErrors: {},
      });

    case TASK_TITLE_LIST_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        taskTitleListLoading: false,
        taskTitleListErrors: action.error,
      });

    case TASK_LIST_UPSERT_INDEX_REQUEST:
      return Object.assign({}, state, {
        indexUpdateLoading: true,
      });

    case TASK_LIST_UPSERT_INDEX_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        indexUpdatePayload: action.data,
        indexUpdateLoading: false,
        indexUpdateErrors: {},
      });

    case TASK_LIST_UPSERT_INDEX_REQUEST_FAILURE:
      return Object.assign({}, state, {
        indexUpdateLoading: false,
        indexUpdateErrors: action.error,
      });

    case FETCH_SUBTASKS_REQUEST:
      return Object.assign({}, state, {
        subTasksLoading: true,
      });

    case FETCH_SUBTASKS_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        subTasksLoading: false,
        subTasksPayload: action.data,
        subTasksErrors: {},
      });

    case FETCH_SUBTASKS_REQUEST_FAILURE:
      return Object.assign({}, state, {
        subTasksLoading: false,
        subTasksErrors: action.error,
      });

    case FETCH_TASK_BY_IDENTIFICATION_REQUEST:
      return Object.assign({}, state, {
        taskByIdLoading: true,
      });

    case FETCH_TASK_BY_IDENTIFICATION_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        taskByIdLoading: false,
        taskById: action.data,
        taskByIdErrors: {},
      });

    case FETCH_TASK_BY_IDENTIFICATION_REQUEST_FAILURE:
      return Object.assign({}, state, {
        taskByIdLoading: false,
        taskByIdErrors: action.error,
      });

    case MARK_TASK_UNREAD_REQUEST:
      return Object.assign({}, state, {
        markTaskUnreadLoading: true,
      });

    case MARK_TASK_UNREAD_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        markTaskUnreadLoading: false,
        markTaskUnreadResponse: action.data,
        markTaskUnreadErrors: {},
      });

    case MARK_TASK_UNREAD_REQUEST_FAILURE:
      return Object.assign({}, state, {
        markTaskUnreadLoading: false,
        markTaskUnreadErrors: action.error,
      });

    case TASK_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        singlePayload: [],
        singleLoading: false,
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
        taskReassign: [],
        taskReassignLoading: false,
        taskSkip: [],
        taskSkipLoading: false,
        taskPark: [],
        taskParkLoading: false,
        indexUpdatePayload: [],
        indexUpdateLoading: false,
        taskById: [],
        taskByIdLoading: false,
      });

    case TASK_ERRORS_CLEAN_REQUEST:
      return Object.assign({}, state, {
        taskTitleListErrors: {},
        errors: {},
        singleErrors: {},
        taskReassignErrors: {},
        taskSkipErrors: {},
        taskParkErrors: {},
        indexUpdateErrors: {},
      });

    default:
      return state;
  }
};

export default taskReducer;
